export default {"src":"/_next/static/media/logo-dvtv.0cd18723.svg","height":40,"width":140,"blurWidth":0,"blurHeight":0};